import UserDepEditorForm from '@/views/kpi/enterprise/my-org-user-list/user-dep-editor-form.vue';
export const useUserDepEditorModal = () => {
  const {
    openComponent
  } = useComponentModal();
  const showUserDepEditorModal = (title, {
    userId,
    depId
  }) => {
    return openComponent(title, UserDepEditorForm, {
      userId,
      depId
    }, {
      showMaximize: false,
      showMinimize: false,
      width: '60%',
      confirmClosable: true
    });
  };
  return {
    showUserDepEditorModal
  };
};